import { request } from '@langlois/request';

export async function cancel ({ commit }, subscriptionId) {
	const url = new URL(`${process.env.VUE_APP_API_URI}/club/subscription/${subscriptionId}/cancel`);

	let response;

	try {
		response = await request.post(url, {});

		const { ok } = response;

		if (!ok) {
			return commit(`vcl/notificationBar/show`, {
				text: `Encountered an error while cancelling the subscription.`,
				type: `warning`
			}, { root: true });
		}

		commit(`cancel`, subscriptionId);
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while cancelling the subscription.`,
			type: `warning`
		}, { root: true });
	}
}
